import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Container } from "reactstrap";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { logout } from "../../../../actions/customer";
import { useNavigate } from "react-router-dom";
import { getDashboard } from "../../../../api/orders";
import { useState,useEffect } from "react";
const DashboardContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [planName, setPlanName] = useState("");
  const [isPlanActive, setIsPlanActive] = useState(true);

  useEffect(() => {
    getDashboard()
      .then((res) => {
        const data = res?.data?.data;
        setPlanName(data?.planName || "");
        setIsPlanActive(Boolean(data?.isPlanActive));
      })
      .catch((err) => {
        console.error("Error fetching dashboard data:", err);
      });
  }, []);

  // 🎯 hide "Search Candidates" if the plan is "Free" OR inactive — either
  // condition alone is enough to hide it, not just both together.
  const shouldShowSearchCandidates = !(
    planName?.toLowerCase() === "free" || isPlanActive === false
  );

  const onLogout = () => {
    dispatch(logout());

    localStorage.removeItem("webvi_authToken");
    localStorage.removeItem("jobseekerspage_userId");
    localStorage.removeItem("webvi_userInfo");

    // 3. Optional: Reset other state slices if necessary
    dispatch({ type: "RESET_USER_STATE" });

    // 4. Force navigation
    navigate("/");
  };

  return (
    <div className="dashboard-wrapper py-4">
      {/* Centered container to hold grid content bounds perfectly */}
      <Container>
        <Row className="g-4 justify-content-center">
          {/* 1. Manage Company */}
          <Col xl={4} md={6} xs={12}>
            <Link to="/employer/company/manage" className="dashboard-card-item">
              <div className="card-icon-wrapper">
                <Icon icon="bi:building" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Manage Company</span>
              </div>
            </Link>
          </Col>

          {/* 2. Search Candidates */}
          {shouldShowSearchCandidates && (
            <Col xl={4} md={6} xs={12}>
              <Link to="/candidates" className="dashboard-card-item">
                <div className="card-icon-wrapper">
                  <Icon icon="bi:search" className="card-icon" />
                </div>
                <div className="card-text-content">
                  <span className="card-title-text">Search Candidates</span>
                </div>
              </Link>
            </Col>
          )}

          {/* 3. Manage Jobs */}
          <Col xl={4} md={6} xs={12}>
            <Link to="/employer/job/manage" className="dashboard-card-item">
              <div className="card-icon-wrapper">
                <Icon icon="uim:bag" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text"> Post & Manage Jobs</span>
              </div>
            </Link>
          </Col>

          {/* 4. Manage Job Applications */}
          <Col xl={4} md={6} xs={12}>
            <Link
              to="/employer/job/application/manage"
              className="dashboard-card-item"
            >
              <div className="card-icon-wrapper">
                <Icon icon="akar-icons:paper" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Manage Applications</span>
              </div>
            </Link>
          </Col>

          {/* 5. Bookmarked Candidates */}
          <Col xl={4} md={6} xs={12}>
            <Link
              to="/employer/bookmark-candidates"
              className="dashboard-card-item"
            >
              <div className="card-icon-wrapper">
                <Icon icon="bi:bookmark-check" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Bookmarked Candidates</span>
              </div>
            </Link>
          </Col>

          {/* 6. My Profile */}
          <Col xl={4} md={6} xs={12}>
            <Link to="/employer/profile" className="dashboard-card-item">
              <div className="card-icon-wrapper">
                <Icon icon="iconoir:profile-circled" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">My Profile</span>
              </div>
            </Link>
          </Col>

          {/* 7. Credits & History */}
          <Col xl={4} md={6} xs={12}>
            <Link to="/employer/orders" className="dashboard-card-item">
              <div className="card-icon-wrapper">
                <Icon icon="lets-icons:order" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Credits &amp; History</span>
              </div>
            </Link>
          </Col>

          {/* 8. Purchased Candidates */}
          <Col xl={4} md={6} xs={12}>
            <Link
              to="/employer/purchased-candidates"
              className="dashboard-card-item"
            >
              <div className="card-icon-wrapper">
                <Icon icon="iconoir:profile-circled" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Unlocked Candidates</span>
              </div>
            </Link>
          </Col>

          {/* 9. Log Out */}
          <Col xl={4} md={6} xs={12}>
            <Link
              to="/"
              onClick={onLogout}
              className="dashboard-card-item card-logout-variant"
            >
              <div className="card-icon-wrapper">
                <Icon icon="akar-icons:sign-out" className="card-icon" />
              </div>
              <div className="card-text-content">
                <span className="card-title-text">Log Out</span>
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DashboardContent;
